<form [formGroup]="speakerFormGroup"
      class="flex-col flex-50 gap-24 narrower-input form-wrapper"
>
  <div class="flex-col gap-8">
    <mat-label>{{ 'SPEAKERS.NAME'|translate }}</mat-label>
    <mat-form-field appearance="outline">
      <input matInput placeholder="" formControlName="name"/>
    </mat-form-field>
  </div>
  <div class="flex-col gap-8">
    <mat-label>{{ 'SPEAKERS.MODEL'|translate }}</mat-label>
    <mat-form-field appearance="outline">
      <mat-select formControlName="model" placeholder="Select Model">
        <mat-option *ngFor="let model of models" [value]="model">
          {{ speakerBrandsStr[model] }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <ng-container [ngSwitch]="selectedModel">
    <ng-container *ngSwitchCase="SpeakerBrands.SIP">
      <div class="flex-col gap-8">
        <mat-label>{{ 'SPEAKERS.DISPLAY_NAME'|translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="" formControlName="displayName"/>
        </mat-form-field>
      </div>
      <div class="flex-col gap-8">
        <mat-label>{{ 'SPEAKERS.SIP_URL'|translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="" formControlName="sipUrl"/>
        </mat-form-field>
      </div>
      <!--      <div class="flex-row start-start">-->
      <!--        <ui-progress-button (clickAction)="testSip()"-->
      <!--                            [disabled]="deviceState.testOngoing || deviceState.testSuccess"-->
      <!--                            [loading]="deviceState.testOngoing"-->
      <!--                            colorText="#4367f6"-->
      <!--                            colorBorder="#4367f6"-->
      <!--                            colorBgr="#ffffff"-->
      <!--                            [preloaderColor]="PreloaderColor.blue"-->
      <!--                            text1="Test"-->
      <!--                            text2="Test"-->
      <!--        ></ui-progress-button>-->
      <!--      </div>-->
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="flex-col gap-8">
        <mat-label>{{ 'SPEAKERS.IP_ADDRESS'|translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="" formControlName="ipAddress"/>
        </mat-form-field>
      </div>
      <div class="flex-col gap-8">
        <mat-label>{{ 'SPEAKERS.PORT'|translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="" formControlName="port"/>
        </mat-form-field>
      </div>
      <div class="flex-col gap-8">
        <mat-label>{{ 'SPEAKERS.USER_NAME'|translate }}</mat-label>
        <mat-form-field appearance="outline">
          <input matInput placeholder="" formControlName="username"/>
        </mat-form-field>
      </div>
      <div class="flex-col gap-8">
        <div class="flex-row space-between-center">

          <mat-label>{{ 'SPEAKERS.PASSWORD'|translate }}</mat-label>
          <div class="flex-row start-center gap-5 c-primary svg-fill-primary icon-14 c-p no-us"
               (click)="hidePassword = !hidePassword;"
          >
            <mat-icon [svgIcon]="hidePassword ? 'eye' : 'eye_closed'"></mat-icon>
            <div>{{ hidePassword ? ('SPEAKERS.SHOW_PASSWORD'|translate) : ('SPEAKERS.HIDE_PASSWORD'|translate) }}</div>
          </div>
        </div>
        <mat-form-field appearance="outline">
          <input matInput [type]="hidePassword ? 'password' : 'text'" placeholder="" formControlName="password"/>
        </mat-form-field>
      </div>
      <div
        *ngIf="deviceState.testSuccess"
        class="flex-row start-center gap-8 success-msg"
      >
        <div class="flex-row center-center gap-8 icon-16 svg-fill-green">
          <mat-icon svgIcon="checkmark-outline"></mat-icon>
          <div>{{ 'SPEAKERS.SPEAKER_CONNECTED'|translate }}</div>
        </div>
      </div>
      <div
        *ngIf="!deviceState.testSuccess && deviceState?.testErrorMsg && !deviceState.testOngoing"
        class="flex-row start-center gap-8 error-msg"
      >
        <div class="flex-row center-center gap-8 icon-16 svg-fill-red">
          <mat-icon svgIcon="status-offline"></mat-icon>
          <div>{{ deviceState.testErrorMsg }}</div>
        </div>
      </div>

      <div class="flex-row start-start">
        <ui-progress-button (clickAction)="test()"
                            [disabled]="deviceState.testOngoing || deviceState.testSuccess"
                            [loading]="deviceState.testOngoing"
                            colorText="#4367f6"
                            colorBorder="#4367f6"
                            colorBgr="#ffffff"
                            [preloaderColor]="PreloaderColor.blue"
                            [text1]="'COMMON.TEST'|translate"
                            [text2]="'COMMON.TEST'|translate"
        ></ui-progress-button>
      </div>
    </ng-container>
  </ng-container>

</form>
